import React from 'react';

// Format YYYY-MM-DD as dd/mm/yyyy for the picker UI.
const formatExpirationDate = (iso) => {
  if (!iso) return null;
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

/**
 * Amber "Lote a recoger" card shown to pickers across the picking flow
 * (location scan, barcode scan, quantity confirmation). Tells the picker
 * which batch (FEFO — soonest expiration first) they should physically
 * grab when a single picking position holds more than one batch.
 *
 * Renders nothing if pickingPosition is missing or has no batch info,
 * so it's safe to drop into screens where the data may not be loaded yet.
 */
const BatchInfoCard = ({ pickingPosition }) => {
  if (!pickingPosition) return null;
  const { batch, expiration_date, quantity } = pickingPosition;
  if (!batch && !expiration_date) return null;

  return (
    <div
      style={{
        margin: '0 auto 16px',
        padding: '12px 16px',
        background: '#fff8e1',
        border: '1px solid #f5d76e',
        borderRadius: '8px',
        color: '#5a4500',
        fontSize: '0.95rem',
        lineHeight: 1.4,
        maxWidth: '320px',
        textAlign: 'left',
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: '4px' }}>Lote a recoger</div>
      {batch && (
        <div>
          <strong>Lote:</strong> {batch}
        </div>
      )}
      {expiration_date && (
        <div>
          <strong>Vence:</strong> {formatExpirationDate(expiration_date)}
        </div>
      )}
      {quantity != null && (
        <div>
          <strong>Disponible:</strong> {quantity}
        </div>
      )}
    </div>
  );
};

export default BatchInfoCard;
